import * as React from "react";
import Box from "@mui/material/Box";
import Sidebar from "../../components/_uiMocks/sidebar/Sidebar";
import { TopNavBar } from "../../components/_uiMocks/_uiComponents/TopNavBar";
import { Footer } from "../_uiComponents/Footer";
import {
     Route,
     Routes,
     BrowserRouter,
     Navigate,
     Outlet,
} from "react-router-dom";
import UiRoutes from "../../routes/UiRoutes";
import { UiAdminHeader } from "../_uiComponents/common/UiAdminHeader";
import { ContentRightWr } from "../_uiComponents/WrapperComponents";

export default function MainWrapper(props) {
     return (
          <>
               <TopNavBar newNotification/>
               <div className="sbt-dashboard-drawer__wr">
                    <UiAdminHeader />
                    <Box sx={{ display: "flex" }}>
                         <div className="sb-desktop-side-bar">
                              <Sidebar />
                         </div>
                         <Box
                              component="main"
                              sx={{
                                   flexGrow: 1,
                                   pt: 0,
                                   pl: 2,
                                   overflow: "hidden",
                              }}
                         >
                              <ContentRightWr>
                                   <UiRoutes />
                              </ContentRightWr>
                         </Box>
                    </Box>
               </div>
               <Footer />
          </>
     );
}
